import React from 'react';
import Input from 'components/ui/Input';
import Icon from 'components/AppIcon';

const SearchBar = ({ searchTerm, onSearchChange, onClearSearch }) => {
  return (
    <div className="relative max-w-md mx-auto mb-8">
      <Input
        type="search"
        placeholder="Search photos by location, activity, or facility..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e?.target?.value)}
        className="pl-10 pr-10"
      />
      <div className="absolute left-3 top-1/2 -translate-y-1/2">
        <Icon name="Search" size={16} className="text-muted-foreground" />
      </div>
      {searchTerm && (
        <button
          onClick={onClearSearch}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md text-muted-foreground hover:text-foreground transition-micro"
          title="Clear search"
        >
          <Icon name="X" size={16} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;